// tituloHelpers.js — Subrayado decorativo bajo el título de una sección.
//
// Es el remate que repiten varias secciones de una misma landing (la barrita
// degradada bajo "BIENVENID@", "METODOLOGÍA", "DOCENTES"). Se pinta con ::after
// para no ensuciar el markup, y solo aparece si la sección define
// `subrayado_titulo`; sin esa clave los títulos quedan exactamente como antes.
//
// Claves de config que lee:
//   subrayado_titulo      color o degradado CSS (es lo que activa el subrayado)
//   subrayado_ancho       ancho de la barra          (default 120px)
//   subrayado_alto        grosor                     (default 4px)
//   subrayado_separacion  hueco entre texto y barra  (default 10px)
//   subrayado_radio       redondeo de las puntas     (default 999px)

// Márgenes laterales del ::after según la alineación del título.
const LADOS = {
  left:   'margin-left: 0; margin-right: auto;',
  center: 'margin-left: auto; margin-right: auto;',
  right:  'margin-left: auto; margin-right: 0;',
};

export const subrayadoCss = (c = {}) => {
  const bg = c.subrayado_titulo;
  if (!bg) return '';
  const align = c.alineacion_titulo || c.alineacion || 'left';
  return `
    &::after {
      content: '';
      display: block;
      width: ${c.subrayado_ancho || '120px'};
      max-width: 100%;
      height: ${c.subrayado_alto || '4px'};
      margin-top: ${c.subrayado_separacion || '10px'};
      ${LADOS[align] || LADOS.left}
      background: ${bg};
      border-radius: ${c.subrayado_radio || '999px'};
    }
  `;
};

export default subrayadoCss;
